import React from "react";
import {
  coachDemoImg,
  CancelIconBlack,
  ClockIconGray,
  LocationIconGray,
  WalletIconGray,
  CalendarIconGray,
} from "../../constant/imagePath";
import css from "./MobileCoachTodoLessonCard.module.css";
import Fonts from "../../stories/assets/Fonts";
import Colors from "../../stories/assets/Colors";
import { Button } from "../Button/Button";
import moment from "moment";

function MobileCoachTodoLessonCard({ lesson, onClick1, onClick2 }) {
  return (
    <div
      style={{
        borderBottom: `1px solid ${Colors.neutralShadesOfWhisper} `,
      }}
      className={css.todoLessonCardMainContainer}
    >
      <div className={css.todoLessonCardhead}>
        <div className={css.imageBox}>
          <img src={lesson?.userData?.profile} alt="" />
        </div>
        <p
          style={{
            ...Fonts.p1,
            color: Colors.neutralShadesOfNero,
          }}
        >
          <span
            style={{
              ...Fonts.b3,
            }}
          >
            {lesson?.userData?.displayName}
          </span>{" "}
          has requested a {lesson?.type} {lesson?.title}
        </p>
      </div>
      <div className={css.todoLessonCardBody}>
        <ul>
          <li className={css.marginTop12}>
            <div>
              <img src={CalendarIconGray} alt="" />
            </div>
            <p
              style={{
                ...Fonts.p1,
                fontSize: "14px",
                color: Colors.neutralShadesOfNero,
              }}
            >
              {moment(lesson?.eventDate).format("MMM DD,YYYY")}
            </p>
          </li>
          <li className={css.marginTop12}>
            <div>
              <img src={ClockIconGray} alt="" />
            </div>
            <p
              style={{
                ...Fonts.p1,
                fontSize: "14px",
                color: Colors.neutralShadesOfNero,
              }}
            >
              {moment(lesson?.startTime).format("hh:mm a")}-
              {moment(lesson?.endTime).format("hh:mm a")}
            </p>
          </li>
          <li className={css.marginTop12}>
            <div>
              <img src={WalletIconGray} alt="" />
            </div>
            <p
              style={{
                ...Fonts.p1,
                fontSize: "14px",
                color: Colors.neutralShadesOfNero,
              }}
            >
              Income ${lesson?.price}
            </p>
          </li>
          <li className={css.marginTop12}>
            <div>
              <img src={LocationIconGray} alt="" />
            </div>
            <p
              style={{
                ...Fonts.p1,
                fontSize: "14px",
                color: Colors.neutralShadesOfNero,
              }}
            >
              {lesson?.location}
            </p>
          </li>
        </ul>
        {lesson?.message && (
          <div
            style={{
              backgroundColor: Colors.neutralShadesOfWhiteSmoke,
            }}
            className={css.message_reply}
          >
            <p
              style={{
                ...Fonts.p1,
                color: Colors.neutralShadesOfNero,
              }}
            >
              {lesson?.message}
            </p>
          </div>
        )}
        <p className={css.line}></p>
      </div>
      <div className={css.todoLessonFooter}>
        <p className={css.time} style={{ ...Fonts.p1, fontSize: "14px" }}>
          {lesson?.timeLeft}
        </p>
        {lesson?.status == "pending" ? (
          <div>
            <Button
              size={"Medium"}
              customStyle={{
                marginRight: "8px",
                color: Colors.neutralShadesOfNero,
                ...Fonts.input1,
                padding: "15px",
              }}
              icon={CancelIconBlack}
              // onClick={onClick1}
            />

            <Button
              size={"Medium"}
              label={"Accept"}
              customStyle={{
                ...Fonts.b2,
                padding: "0px 54px",
                border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                width: "156px",
              }}
              primary={true}
              // onClick={onClick2}
            />
          </div>
        ) : lesson?.status == "accepted" ? (
          <div>
            <Button
              size={"Medium"}
              customStyle={{
                marginRight: "8px",
                color: Colors.neutralShadesOfNero,
                ...Fonts.input1,
              }}
              icon={CancelIconBlack}
              // onClick={onClick1}
            />

            <Button
              size={"Medium"}
              label={"Cancel"}
              customStyle={{
                padding: "0px 54px",
                border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                width: "156px",
              }}
              primary={false}
              isTertiary={true}
              // onClick={onClick2}
            />
          </div>
        ) : lesson?.status == "evaluate" ? (
          <div>
            <Button
              label={"Evaluate"}
              size="Medium"
              customStyle={{
                ...Fonts.b2,
                padding: "0",
                border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                width: "212px",
              }}
              primary={true}
              onClick={onClick1}
            />
          </div>
        ) : (
          lesson?.status == "read-evaluation" && (
            <div>
              <Button
                size="Medium"
                label={"Read evaluation"}
                customStyle={{
                  padding: "0",
                  border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                  width: "212px",
                }}
                primary={false}
                isTertiary={true}
              />
            </div>
          )
        )}
      </div>
    </div>
  );
}

export default MobileCoachTodoLessonCard;
